<section
  class="bg-white p-4 tablet:p-5 desktop:p-6 pointer-events-auto"
  [ngClass]="{ 'opacity-50 pointer-events-none select-none': isDisabled() }"
>
  <div *ngIf="title" class="flex justify-between items-center mb-3">
    <h2 class="text-mobileH2 tablet:text-tabletH2 font-headline desktop:text-desktopH2">
      {{ title | scTranslate | async }}
    </h2>
  </div>
  <p
    *ngIf="title && subTitle"
    class="text-mobileMd tablet:text-tabletMd mb-4 desktop:text-desktopMd tablet:mb-5 desktop:mb-6"
  >
    {{ subTitle | scTranslate | async }}
  </p>
  <ng-content></ng-content>
</section>
